<template>
  <a-modal
    v-model="visible"
    :title="title"
    :width="1000"
    :footer="null"
    destroyOnClose
    class="month-detail-modal"
  >
    <TableList
      style="width: 100%; margin-top: 5px"
      :columns="columns"
      :tableData="dataSource"
      :loading="loading"
      :scroll="{}"
      :pagination="ipagination"
      @change="handleTableChange"
    />
  </a-modal>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TableList from '@comp/chart/TableList.vue'
import { getAction } from '@api/manage'

export default {
  name: 'NotCollectedDetailModal',
  mixins: [JeecgListMixin],
  components: {
    TableList,
  },
  props: {
    tabKey: {
      type: Number,
      default: 1,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    url: {
      type: Object,
      default: () => ({
        list: '/aigoes/studentWithoutFaceRecord/list',
        // exportXlsUrl: '/schoolEvaluationRecord/exportXls',
        // 教师使用情况导出
        // exportXlsUrl: '/aigoes/studentWithoutFaceRecord/list',
      }),
    },
  },
  computed: {
    title() {
      return this.tabKey == 1 ? '有底图未采集' : '无底图'
    },
  },
  data() {
    return {
      visible: false,
      disableMixinCreated: true,
      remindLoading: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '班主任',
          dataIndex: 'teacherName',
          align: 'center',
        },
        {
          title: '反馈原因',
          dataIndex: 'noCollectReason',
          align: 'center',
          customRender: (_, record) => {
            return record.noCollectReason.length >= 15 ? (
              <a-tooltip>
                <template slot="title">{record.noCollectReason}</template>
                {record.noCollectReason.substring(0, 15) + '...'}
              </a-tooltip>
            ) : (
              record.noCollectReason
            )
          },
        },
        {
          title: '反馈时间',
          dataIndex: 'commitReasonTime',
          align: 'center',
        },
      ],
    }
  },
  watch: {
    // tabKey为1有添加未采集时间列，2无未采集时间列
    tabKey: {
      handler(val) {
        const isHas = this.columns.some((item) => item.dataIndex === 'notCollectTime')
        if (val == 1 && !isHas) {
          this.columns.splice(4, 0, {
            title: '未采集时间',
            dataIndex: 'notCollectTime',
            align: 'center',
          })
          return
        }
        if (isHas) {
          this.columns.splice(4, 1)
        }
      },
      immediate: true,
    },
  },
  methods: {
    showModal(data) {
      this.dataSource = []
      this.queryParam = {
        type: this.tabKey,
        studentId: data.studentId,
      }
      this.visible = true
      this.loadData(1)
    },
    hideModal() {
      this.visible = false
    },
  },
}
</script>
<style scoped lang="less">
.month-detail-modal {
  /deep/ .ant-modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  /deep/ .ant-modal-body {
    min-height: 450px;
    padding: 10px 24px;
  }
  /deep/ .ant-modal-footer {
    padding-top: 16px;
    padding-bottom: 16px;
    border-top: 1px solid #ececec;
  }
}
</style>
